import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@e2n/ui';
import { cn } from '@/lib/utils';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateTerminKalenderForm } from '@/domain/termine/features/UpdateTerminkalender/shared';
import { useTerminKalenderList } from '@/domain/termine/hooks/useTerminKalenderList';
import { UpdateTerminKalenderDrawerForm } from '@/domain/termine/features/UpdateTerminkalender/Mobile/UpdateTerminKalenderDrawerForm';

type UpdateTerminKalenderDrawerProps = {
  onOpenChange: (open: boolean) => void;
  selectedId: string;
  open: boolean;
};

function UpdateTerminKalenderDrawerFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 items-center justify-center text-sm">
      <FontAwesomeIcon
        icon={faSpinnerThird}
        className="text-primary-blue-200"
        spin
        size="4x"
      />
      {t('actions.loading')}
    </div>
  );
}

export function UpdateTerminKalenderDrawer({
  onOpenChange,
  selectedId,
  open,
}: UpdateTerminKalenderDrawerProps) {
  const { kalender } = useTerminKalenderList();
  const selectedKalender = kalender.find((k) => k.id === selectedId);
  const { t } = useTranslation();
  const form = useUpdateTerminKalenderForm(selectedKalender);

  const handleSubmitSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Drawer
      repositionInputs={false}
      open={open}
      onOpenChange={(open) => {
        if (!open) onOpenChange(false);
      }}
      dismissible>
      <DrawerContent
        showHandle={false}
        className={cn(
          'h-svh w-screen',
          'rounded-none border-0',
          'data-[vaul-drawer-direction=bottom]:mt-0',
          'data-[vaul-drawer-direction=bottom]:max-h-none',
          'data-[vaul-drawer-direction=bottom]:rounded-none',
          'data-[vaul-drawer-direction=bottom]:border-0',
        )}>
        <DrawerTitle className="sr-only">
          {t('domain.termine.kalender.form.neuerKalender')}
        </DrawerTitle>
        <DrawerDescription className="sr-only">
          {t('domain.termine.kalender.form.neuerKalender')}
        </DrawerDescription>
        <Suspense fallback={<UpdateTerminKalenderDrawerFallback />}>
          <UpdateTerminKalenderDrawerForm
            form={form}
            onSubmitSuccess={handleSubmitSuccess}
          />
        </Suspense>
      </DrawerContent>
    </Drawer>
  );
}
